module.exports = __webpack_public_path__ + "static/media/语音转译（语音转文字).28af70e1.png";